import { Styles, css, extractTransition, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  loadingContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  `,
  copyButtonContainer: css`
    position: sticky;
    top: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  `,
  viewOnIndeedLink: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;

    text-decoration: none;

    background-color: ${theme.colors.neutral.variant[20]};
    padding-left: 4px;
    padding-right: 8px;
    border-radius: 11px;

    color: ${theme.colors.neutral.variant[70]};

    ${extractTransition((f) => f.cubic, { duration: 120, property: ['background-color'] })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[30]};
    }
  `,
  previewContainer: ({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0 8px;

    ${verticalScrollCss(theme)};
  `,
  vacancyDescription: css`
    & > p {
      margin: 0;
    }

    & > ul {
      margin: 0;
      padding-left: 32px;
    }
  `,
  atsDisconnectedContainer: ({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 12px 16px;
    border: solid 1px ${theme.colors.neutral.variant[30]};
    border-radius: 8px;
    width: 383px;
    margin: auto;
  `,
  atsDisconnectedText: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    a {
      color: ${theme.colors.secondary.sky[50]};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
